import type { DataTableColumn, GridRenderCellParams } from '@/components/custom/erp';
import type { KhuVuc } from '@/types/schemas/khu-vuc.type';

type KhuVucTableRow = KhuVuc & {
  nh_rg1_group_data?: string;
};

export function getDataTableColumns(): DataTableColumn<KhuVucTableRow>[] {
  return [
    {
      field: 'rg_code',
      headerName: 'Mã khu vực',
      width: 150
    },
    {
      field: 'rgname',
      headerName: 'Tên khu vực',
      width: 250
    },
    {
      field: 'parent',
      headerName: 'Khu vực mẹ',
      width: 150,
      renderCell: (params: GridRenderCellParams<KhuVucTableRow>) => {
        return params.row.parent_rg_data?.rg_code ?? '';
      }
    },
    {
      field: 'nh_rg1_group',
      headerName: 'Nhóm 1',
      width: 150,
      renderCell: (params: GridRenderCellParams<KhuVucTableRow>) => {
        return params.row.nh_rg1_group_data ?? '';
      }
    }
  ];
}
